<template>
  <ul class="list-group" style="margin-top: 8px;">
    <li class="list-group-item d-flex justify-content-between align-items-center"
      v-for="file in files" :key="file.id"
    >
      <div>
        <a :href="`/roll_outs/${rollOutId}/key_account/files/${file.id}`" target="_blank">
          {{ file.original_name }}
        </a><br>
        <small>Uploaded on {{ file.created_at | datetime }}</small>
      </div>
      <button class="btn btn-secondary btn-sm" @click="$emit('deleteImage', file)">
        <i class="fa fa-trash-alt"></i>
      </button>
    </li>
  </ul>
</template>

<script>
  import {datetime} from './../filters'

  export default {
    props: {
      files: {
        required: true,
      },
      rollOutId: null,
    },
    filters: {
      datetime,
    },
  }
</script>

<style>
.delete-image {
  position: absolute;
  top: -8px;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/FilesGallary.vue